import { OddStyles } from "../../data";
export class SelectionSortFuncs {
    static Sort(marketTypeId) {
        return SelectionSortFuncs.Funcs[marketTypeId];
    }
}
SelectionSortFuncs.outcomeTypeOrder = ["Home", "Tie", "Away", "Over", "Under"];
SelectionSortFuncs.secondLineOutcomeType = ["Away", "Under"];
/* istanbul ignore next */
SelectionSortFuncs.SortByOutcomeType = (sel1, sel2) => {
    if (SelectionSortFuncs.outcomeTypeOrder.indexOf(sel1.outcomeType) === -1) {
        return 1;
    }
    let sel1OrderIndex = SelectionSortFuncs.outcomeTypeOrder.indexOf(sel1.outcomeType);
    let sel2OrderIndex = SelectionSortFuncs.outcomeTypeOrder.indexOf(sel2.outcomeType);
    return sel1OrderIndex - sel2OrderIndex;
};
/* istanbul ignore next */
SelectionSortFuncs.SortByOutcomeTypeAndPointsHC = (sel1, sel2) => {
    if (SelectionSortFuncs.outcomeTypeOrder.indexOf(sel1.outcomeType) === -1) {
        return 1;
    }
    /* istanbul ignore next */
    let sel1OrderIndex = SelectionSortFuncs.secondLineOutcomeType.indexOf(sel1.outcomeType) !== -1
        ? -sel1.points
        : sel1.points;
    /* istanbul ignore next */
    let sel2OrderIndex = SelectionSortFuncs.secondLineOutcomeType.indexOf(sel2.outcomeType) !== -1
        ? -sel2.points
        : sel2.points;
    /* istanbul ignore next */
    if (sel1OrderIndex > sel2OrderIndex) {
        return 1;
    }
    /* istanbul ignore next */
    if (sel1OrderIndex < sel2OrderIndex) {
        return -1;
    }
    return SelectionSortFuncs.SortByOutcomeType(sel1, sel2);
};
/* istanbul ignore next */
SelectionSortFuncs.SortByOutcomeTypeAndPointsOU = (sel1, sel2) => {
    if (SelectionSortFuncs.outcomeTypeOrder.indexOf(sel1.outcomeType) === -1) {
        return 1;
    }
    /* istanbul ignore next */
    if (sel1.points > sel2.points) {
        return 1;
    }
    /* istanbul ignore next */
    if (sel1.points < sel2.points) {
        return -1;
    }
    return SelectionSortFuncs.SortByOutcomeType(sel1, sel2);
};
SelectionSortFuncs.SortByOdd = (sel1, sel2) => {
    let odd1 = sel1.displayOdds[OddStyles.decimal];
    let odd2 = sel2.displayOdds[OddStyles.decimal];
    if (odd1 === "SP") {
        return 1;
    }
    if (odd2 === "SP") {
        return -1;
    }
    let decimalOdd1 = parseFloat(odd1);
    let decimalOdd2 = parseFloat(odd2);
    if (decimalOdd1 < decimalOdd2) {
        return -1;
    }
    if (decimalOdd1 > decimalOdd2) {
        return 1;
    }
    return 0;
};
SelectionSortFuncs.Funcs = {
    ML: SelectionSortFuncs.SortByOutcomeType,
    HC: SelectionSortFuncs.SortByOutcomeTypeAndPointsHC,
    OU: SelectionSortFuncs.SortByOutcomeTypeAndPointsOU,
    QA: SelectionSortFuncs.SortByOdd,
    MLET: SelectionSortFuncs.SortByOutcomeType,
    TGET: SelectionSortFuncs.SortByOutcomeTypeAndPointsOU,
    TQ: SelectionSortFuncs.SortByOutcomeType,
    PW: SelectionSortFuncs.SortByOutcomeType
};
//# sourceMappingURL=SelectionSortFuncs.js.map